import { render, staticRenderFns } from "./tempPenyeragamanGredPP012016.vue?vue&type=template&id=4026ec42&"
import script from "./tempPenyeragamanGredPP012016.vue?vue&type=script&lang=js&"
export * from "./tempPenyeragamanGredPP012016.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports